import { Payment } from './Payment'
import { Order } from './Order'
import { DeliveryDetails } from './DeliveryDetails'

export class Sale {

    constructor(
        public id: string,
        public order: Order,
        public deliveryDetails: DeliveryDetails | null,
        public dateCreated: Date,
        public payment: Payment | null = null,
        public purpose: SalePurpose = SalePurpose.VoucherPurchase
    ) { }

    remainingLineAmount(lineId: string): number {
        const line = this.order.lineItems.find(item => item.id === lineId)
        return line ? line.unitAmount() * line.quantity - (this.payment?.amountRefundedForLine(lineId) ?? 0) : 0
    }

    isLineRefunded(lineId: string): boolean {
        return (this.payment?.amountRefundedForLine(lineId) ?? 0) > 0 && this.remainingLineAmount(lineId) === 0
    }
}

export enum SalePurpose {
    VoucherPurchase = 'VOUCHER_PURCHASE',
    BookingOrder = 'BOOKING_ORDER',
}
